export const Api_Url = `https://demoapicms.scizersinfotech.com`
